import clsx from "clsx";
import React, { FunctionComponent, SVGProps } from "react";

export const PartlyCloudyIcon: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  className,
  ...props
}) => {
  return (
    <svg
      {...props}
      className={clsx("tw-icon", className)}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M6.948 2.364a.75.75 0 0 1 .868.608l.27 1.53a5.25 5.25 0 0 1 2.53.56l.89-1.271a.75.75 0 0 1 1.229.86l-.89 1.272c.342.32.638.686.882 1.084A7.125 7.125 0 1 1 14.625 21h-7.5a4.878 4.878 0 0 1-4.697-3.582 4.875 4.875 0 0 1 1.382-4.864 5.25 5.25 0 0 1-.549-1.165l-1.528.27a.75.75 0 1 1-.26-1.478L3 9.911a5.25 5.25 0 0 1 .562-2.529l-1.272-.89a.75.75 0 1 1 .86-1.229l1.272.89A5.25 5.25 0 0 1 6.61 4.763l-.27-1.53a.75.75 0 0 1 .609-.868Zm.61 3.7a3.75 3.75 0 0 0-2.504 5.65 4.874 4.874 0 0 1 2.919-.39 7.124 7.124 0 0 1 3.33-3.752 3.748 3.748 0 0 0-3.746-1.509Zm.027 6.717a3.377 3.377 0 0 0-3.71 4.239 3.375 3.375 0 0 0 3.25 2.48h7.5A5.625 5.625 0 1 0 9 13.875a.75.75 0 0 1-1.5 0c0-.368.029-.734.085-1.094Z"
        fillRule="evenodd"
      />
    </svg>
  );
};
